import { ChangeEvent, FC } from 'react';
import styles from './Textarea.module.scss';

interface TextareaProps {
  name: string;
  value?: string;
  onChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  placeholder: string;
  title: string;
  textCount?: number;
}

const Textarea: FC<TextareaProps> = ({ name, value = '', onChange, placeholder, title, textCount = 100 }) => {
  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    if (e.target.value.length > textCount) e.target.value = e.target.value.slice(0, textCount);
    onChange(e);
  };

  return (
    <div className={styles.container}>
      {title && <div className={styles.title}>{title}</div>}
      <textarea
        name={name}
        className={styles.textarea}
        value={value}
        placeholder={placeholder}
        onChange={handleChange}
      />
      <span className={styles.textCount}>{`${value.length}/${textCount}`}</span>
    </div>
  );
};

export default Textarea;
